module.exports = __webpack_public_path__ + "static/media/Diamond_orange.802aed20.svg";